import React, {useEffect, useState} from 'react';
import {ArticleApi, ArticleDto, AttachmentDto} from '../../scaffold';
import {useInput} from 'react-hanger';
import {Button, Col, DatePicker, Form, Input, message, Row, Space} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment, {Moment} from 'moment';
import BraftEditor from 'braft-editor';
import ExBraftEditor from '../ExBraftEditor';
import UploadImage from '../UploadImage';
import UploadAttachment, {UploadAttachmentDto} from '../UploadAttachment';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
export default function ArticleEditForm(props: {onSuccess?: (res: ArticleDto) => any; article?: ArticleDto; onCancel?: () => any; catalogs: string}) {
  const title = useInput('');
  const description = useInput('');
  const department = useInput('');
  const author = useInput('');
  const coverPath = useInput('');
  const [publishedDate, _publishedDate] = useState<Moment>();
  const [content, _content] = useState(BraftEditor.createEditorState(null));
  const [attachments, _attachments] = useState<UploadAttachmentDto[]>([]);

  const saveHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleSavePost);

  useEffect(() => {
    if (props.article) {
      title.setValue(props.article?.title || '');
      description.setValue(props.article?.description || '');
      department.setValue(props.article?.description || '');
      author.setValue(props.article?.description || '');
      _publishedDate(moment(props.article.publishedDate));
      _content(BraftEditor.createEditorState(props.article.content));
      coverPath.setValue(props.article?.coverPath || '');
      _attachments(props.article?.attachments?.map(i => ({name: i.name || '', path: i.path, uid: i.id?.toString() || ''})) || []);
    } else {
      title.clear();
      description.clear();
      department.clear();
      author.clear();
      _publishedDate(undefined);
      _content(BraftEditor.createEditorState(null));
      coverPath.clear();
      _attachments([]);
    }
  }, [props.article]);

  function onSubmit() {
    saveHook
      .request({
        saveArticleParams: {
          id: props.article?.id,
          title: title.value,
          description: description.value,
          department: department.value,
          author: author.value,
          publishedDate: publishedDate?.format('YYYY-MM-DD') || '',
          content: content.toRAW(),
          coverPath: coverPath.value,
          attachmentList: attachments.map(i => ({name: i.name || '', path: i.path || ''})),
          catalogs: props.catalogs,
        },
      })
      .then(res => {
        props.onSuccess && props.onSuccess(res);
        return message.success('操作成功');
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <div>
      <Form layout={'vertical'}>
        <Row gutter={20}>
          <Col span={18}>
            <Form.Item required label={'标题'}>
              <Input {...title.eventBind} />
            </Form.Item>
            <Form.Item required label={'正文'}>
              <ExBraftEditor value={content} onChange={_content} />
            </Form.Item>
            <Form.Item label={'附件'}>
              <UploadAttachment value={attachments} onChange={_attachments} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label={'版块'}>
              <Input value={props.catalogs} disabled />
            </Form.Item>
            <Form.Item label={'发布者'}>
              <Input {...author.eventBind} />
            </Form.Item>
            <Form.Item label={'部门'}>
              <Input {...department.eventBind} />
            </Form.Item>
            <Form.Item required label={'发布时间'}>
              <DatePicker style={{width: '100%'}} value={publishedDate} onChange={e => _publishedDate(e as Moment)} />
            </Form.Item>
            <Form.Item label={'摘要'}>
              <TextArea rows={4} {...description.eventBind} />
            </Form.Item>
            <Form.Item label={'缩略图'}>
              <UploadImage {...coverPath.valueBind} />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button type={'primary'} onClick={onSubmit}>
                  保存
                </Button>
                <Button onClick={props.onCancel}>取消</Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
